import "./style.css";
import { Box, Button, Typography } from "@mui/material";
import logo from "../../Assets/Images/logo.png";
import HelmetReact from "../../Components/Helmet";
import CheckCircleOutlineTwoToneIcon from "@mui/icons-material/CheckCircleOutlineTwoTone";

function ForgotMsg() {
  return (
    <>
      <HelmetReact name="Forget-Password" />
      <Box className="forget-passwordForm">
        <Box className="form-contianer">
          <Box className="logo">
            <img src={logo} className="brand-logo" alt=""></img>
          </Box>
          <Box  sx={{ textAlign: "center"}}>
            <CheckCircleOutlineTwoToneIcon className="custom-check" />
          </Box>

          <Box className="input forget-password-input">
            <Box sx={{ textAlign: "center", fontSize: "24px", display: "flex", flexDirection: "row", flexWrap: "wrap"  }}>
              Your password has been changed successfully. 
              Please log in to the app with the new password. Oncio Team Thank You.
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default ForgotMsg;
